import React, { Component } from 'react';
class WhatsAppButton extends Component {
	render(props) {
		return (
			<div className={this.props.classes}>
				<a
					title={this.props.title}
					href={this.handleHref()}
					target={this.props.target}
					rel={this.handleRel()}></a>
			</div>
		);
	}

	handleHref = props => {
		return this.props.message
			? this.props.send_url + this.props.phone + '&text=' + this.props.message
			: this.props.send_url + this.props.phone;
	};

	handleRel = () => {
		return this.props.target === '_blank' ? 'noopener noreferrer' : '';
	};
}

WhatsAppButton.defaultProps = {
	send_url: 'https://api.whatsapp.com/send?phone=',
	classes: 'box-contact--fixed',
	title: 'Precisa de ajuda?',
	target: '_blank'
};

class WhatsAppBtn extends Component {
	render(props) {
		return (
			<WhatsAppButton
				message={this.handleTextMessage()}
				phone={this.props.phone}
			/>
		);
	}

	handleTextMessage = () => {
		return window.location.href.indexOf('/bv') !== -1
			? this.props.message + ' BV'
			: this.props.message;
	};
}

export default WhatsAppBtn;
